import { CatButton } from '@blocks-react/components/Button';

interface DealerLocatorViewMoreResultsButtonProps {
  children: string;
  onClick: () => void;
  isDisabled?: boolean;
}

export const DealerLocatorViewMoreResultsButton = ({
  children,
  onClick,
  isDisabled,
}: DealerLocatorViewMoreResultsButtonProps) => (
  <div className="w-100 text-center my-3">
    <CatButton
      className="text-center"
      onClick={onClick}
      disabled={isDisabled}
    >
      {children}
    </CatButton>
  </div>
);
